import * as ko from "knockout";
import Bao from "./../../services/bao-service";
function TicketModuleViewModel(parent) {
    var self = this;
    self.Bao = Bao;
    self.parent = parent;
    self.Initialized = ko.observable(false);
    self.DashboardUrl = ko.observable();
    self.BirthdayCollection = ko.observableArray([]);
    self.TotalRows = ko.observable(0);
    self.ShowBirthdayModule = ko.observable(false);
    self.PageSize = ko.observable(20);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.SelectedRow = ko.observable({});
    self.SelectRow = function (item) {
        self.SelectedRow(item);
        return true;
    };
    self.DisplayTotalRows = ko.computed(function () {
        if (self.TotalRows() <= self.PageSize()) {
            return self.TotalRows();
        }
        else {
            return self.PageSize() + " / " + self.TotalRows();
        }
    });
    self.PageIndex.subscribe(function () {
        self.Load();
    });
    self.Sorting.subscribe(function () {
        self.SaveSelectedSort(self.Sorting());
        self.Load();
    });
    self.Load = function () {
        var def = $.Deferred();
        if (self.Initialized()) {
            Bao.post("SynosetStartModule/GetBirthdays", JSON.stringify({
                pageIndex: self.PageIndex(),
                pageSize: self.PageSize(),
                sorting: self.Sorting()
            }), function (searchResult) {
                self.SelectedRow(null);
                self.TotalRows(0);
                self.BirthdayCollection([]);
                if (searchResult != null && searchResult.Models != null) {
                    self.BirthdayCollection(searchResult.Models);
                    self.TotalRows(searchResult.TotalRows);
                    self.ShowBirthdayModule(self.TotalRows() > 0);
                    var checker = self.ShowBirthdayModule();
                    var checker2 = checker;
                }
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.init = function () {
        return Bao.post("SynosetStartModule/GetBirthdays", JSON.stringify({}), function (searchResult) {
            if (searchResult != null) {
                if (searchResult.SelectedSorting != null) {
                    var sortObj = new Object();
                    sortObj = {
                        "Column": searchResult.SelectedSorting[0],
                        "Direction": searchResult.SelectedSorting[1]
                    };
                    self.Sorting([sortObj]);
                }
            }
            self.Initialized(true);
        });
    };
    self.loaded = function () {
        return self.Load();
    };
    self.parent.Refresh = function () {
        self.Load();
    };
}
export default TicketModuleViewModel;